import * as Types from './messaging_gql.generated';

import { gql } from 'graphql.macro';
import * as Apollo from '@apollo/client';
export type UpdateMessageMutationVariables = Types.Exact<{
  conversationUuid: Types.Scalars['UUID'];
  messageUuid: Types.Scalars['UUID'];
  readAt: Types.Scalars['DateTime'];
}>;


export type UpdateMessageMutation = (
  { __typename?: 'Mutations' }
  & { updateMessage?: Types.Maybe<(
    { __typename?: 'UpdateMessage' }
    & Pick<Types.UpdateMessage, 'ok'>
  )> }
);


export const UpdateMessageDocument = gql`
    mutation UpdateMessage($conversationUuid: UUID!, $messageUuid: UUID!, $readAt: DateTime!) {
  updateMessage(
    conversationUuid: $conversationUuid
    messageUuid: $messageUuid
    readAt: $readAt
  ) {
    ok
  }
}
    `;
export type UpdateMessageMutationFn = Apollo.MutationFunction<UpdateMessageMutation, UpdateMessageMutationVariables>;
export type UpdateMessageMutationResult = Apollo.MutationResult<UpdateMessageMutation>;
export type UpdateMessageMutationOptions = Apollo.BaseMutationOptions<UpdateMessageMutation, UpdateMessageMutationVariables>;